<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:header></template>
      <template v-slot:actions>
        <v-btn color="primary" @click="$refs.table.updateData()"><btn-title icon="fas fa-sync-alt">Обновить</btn-title></v-btn>
        <v-btn v-if="false" color="primary" @click="createNew()" title="Создать элемент"><btn-title icon="far fa-plus-square">Создать</btn-title></v-btn>
      </template>
      <portal to="v-main">
        <s-edit-form v-model="showEditDialog" v-if="showEditDialog" :api="url" :m="m" :config="configHead" :title="configHead.title" :id="idEdit" />
      </portal>
      <a-table-f-api
        ref="table"
        :api="url"
        :model="model"
        :selectedRows="selectedRows"
        :useQuery="true"
        :defaults="defaults"
        @click="
          counter += 1;
          onDetectClick($event);
        "
      />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, doubleClickDetect, popupMenu } from "@/components/mixings";
export default {
  mixins: [getAccess, doubleClickDetect, popupMenu],
  components: {
    ViewItem: () => import("./views/invoiceView"),
  },
  data() {
    return {
      idEdit: 0,
      showEditDialog: false,
      idItemShow: 0,
      showDetail: false,
      title: "",
      m2: this.$store.getters["config/get"].models.invoice,
      m: {
        title: "Счета на оплату",
        routeName: "invoce_view",
        accessName: "invoice",
        isDocument: false,
        api: "/accounting/doc/invoice",
        accDocName: "AccountingDocInvoice",
        operations: [],
        statuses: [
          { value: -1, text: "Новый счет на оплату", next: [1] },
          { value: 1, text: "Активный", next: [3], action: "Выставить счет" },
          { value: 2, text: "Оплачен", next: [], action: "" },
          { value: 3, text: "Отменен", next: [-1], action: "Отменить" },
        ],

        form: [
          { name: "name", title: "Заголовок", type: "string", validator: ["req"], setReadonly: true },
          { name: "description", title: "Описание", type: "text", setReadonly: true },
          { name: "status", title: "Статус", validator: ["req"], sourceList: "statuses", default: 0 },
          { name: "amount", title: "Сумма", type: "number" },

          { name: "createdon", title: "Дата создания", type: "datetimestring", hidden: false },
          { name: "filesRemove", default: [], hidden: true },
          { name: "filesAdd", default: [], hidden: true },
          { name: "docs", title: "Документы", type: "filesdata", category: 1, hiddenCreate: false },
          { name: "data.client_id", title: "Клиент", type: "select", dir: "client", validator: ["req"], autocomplete: true },
          { name: "vendor_id", title: "Юридическое лицо", type: "select", dir: "vendor", validator: ["req"], autocomplete: true },
        ],
        list: [
          { name: "id", title: "#", type: "id", sortable: true, width: 60, hidden: false },
          { name: "createdon", title: "Дата", type: "datetime", sortable: true, width: 150, hidden: false },

          { name: "vendor_id", title: "Юридическое лицо", type: "select", dir: "vendor", sortable: true, width: 200, style: "white-space: normal;" },
          { name: "amount", title: "Сумма", type: "number", sortable: true, width: 100 },
          {
            name: "creator_name",
            title: "Кем создана",
            type: "string",
            filter: { type: "selectapi", name: "createdby_id", api: "/manager/users/select", filters: { status: 1 } },
            sortable: true,
            width: 150,
          },
          { name: "status", title: "Статус", type: "select", sortable: true, width: 150, sourceList: "statuses", style: "white-space: normal;" },
        ],
        viewForm1: { fields: "vendor_id,data.client_id,description" },
        viewForm2: { fields: "company_id,object_name,is_important,amount,date_end,date_start" },
        config: {
          default: {
            title: "Заявка на оплату",
            fields: "name,type,createdon,creator_name,amount,date_start,is_important,docs,description,filesAdd,status,date_end,payment_type,company_id",
            fieldsRO: "createdon,creator_name,is_important",
            fieldsForm: "name,type#5,payment_type#4,is_important#3,createdon#4,creator_name#4,company_id#4,amount#4,date_start#4,date_end#4,description,docs",
          },
          create: {
            title: "Новая заявка на оплату",
            fields: "name,type,createdon,creator_name,amount,is_important,docs,description,filesAdd,status,date_end,payment_type,company_id",
            fieldsRO: "createdon,creator_name,is_important",
            fieldsForm: "name,type#5,payment_type#4,is_important#3,createdon#4,creator_name#4,company_id#4,amount#6,date_end#6,description,docs",
          },
        },
        accDocName: "Inoice",
      },

      defaults: {
        // filters: { status: 1 },
        sort: { key: "id", order: "DESC" },
        paramName: "invoice",
      },
    };
  },
  created() {
    this.$root.title = this.m.title;
  },
  computed: {
    configHead() {
      return this.m.config.default || {};
    },
    url() {
      let api = this.m.api;
      // if (this.getAccess("invoice.viewAll")) api = api + "_admin";
      return api;
    },
    model() {
      let model = JSON.parse(JSON.stringify(this.m.list));
      model.forEach(el => {
        if (el?.sourceList) {
          el.options = this.m[el.sourceList];
        }
      });
      return model;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
    showDetail(v) {
      if (!v) {
        this.idItemShow = 0;
        this.$emit("onClose");
      }
    },
  },
  methods: {
    onClickRow(d) {
      this.$router.push({ name: this.m.routeName, params: { id: d.row.id } });
    },
    onSingleClick(d) {
      if (d.field?.isMenu) {
        this.showPopupMenu(d.field.name, d.row, d.event);
      }
    },
    onDoubleClick(d) {
      this.idItemShow = d.row.id;
      return;
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
  },
};
</script>
